export default __webpack_public_path__ + "static/media/Jan-belshaw-french-english-teacher.a87d05e6.webp";